/**
 * 转入其他系统需要的接口api
 */
import Vue from "vue";
import axios from '@/utils/http';
const api = {
  //获取跳转到qcin 得token标记
  qclogin() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/qclogin`, {
      mask:false
    });
  },
  qcinlogin() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/qcinlogin`, {
      mask:false
    });
  },
  etlogin() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/etlogin`, {
      mask:false
    });
  },
  alletlogin() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/alletlogin`, {
      mask:false
    });
  },
  masterlogin() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/masterlogin`, {
      mask:false
    });
  },
  //获取跳转到qcin需要的参数
  qcinParam(_item1,_editFlg,_newNo,_queryFlg) {
    var _params = {
      item1:_item1,
      editFlg:_editFlg,
      newNo:_newNo,
      queryFlg:_queryFlg
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/qcparam`, {
      mask:false,
      params: _params
    });
  },
  //获取系统跳转路径 _flg 0:qc 1:电子传票 2:全店发票 3:master 4:qcin
  jumppath(_flg) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/skip/jumppath`, {
      mask:false,
      params: {
        sysFlg:_flg
      }
    });
  }
}

export default api;



// WEBPACK FOOTER //
// ./src/api/otherSkip.js